import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useMemo, useState } from "react";
import { ColumnDescription } from "react-bootstrap-table-next";
import ModalComponent from "../../../Components/Modais";
import { IComponentModal } from "../../../Components/Modais/IModalComponent";
import Table from "../../../Components/Table";
import { ListarFormulariosRespondidosPorCasoController } from "../../../Controllers/Geral/Formularios/FormulariosControllers";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import { IAtendimentoExtraDetalhado } from "../../../Interfaces/Geral/Atendimento/AtendimentoExtraDetalhadoInterfaces";
import { IFormulariosRespondidos } from "../../../Interfaces/Geral/Formularios/FormulariosInterface";
import VisualizarFormulario from "../../../Pages/Geral/Formularios/VisualizarFormulario";

interface IGestaoModeloVendasProps {
    Atendimento: IAtendimentoExtraDetalhado;
}

export default function GetFormulariosPorConta(
    props: IGestaoModeloVendasProps
) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        value: listarFormulariosRespondidosPorCasoResponse,
        loading,
        execute: updateList,
    } = useAsyncEffect(async () => {
        return ListarFormulariosRespondidosPorCasoController(
            props.Atendimento.ID_CASO
        );
    }, [props.Atendimento.ID_CASO]);

    // const {
    //     value: listarFormulariosRespondidosResponse,
    //     loading,
    //     execute: updateList,
    // } = useAsyncEffect(async () => {
    //     return ListarFormulariosRespondidosController(
    //         props.Atendimento.ID_CONTA
    //     );
    // }, [props.Atendimento.ID_CONTA]);

    function getColumns(updateList: () => void) {
        const tableViewColumns: Array<
            ColumnDescription<IFormulariosRespondidos>
        > = [
            {
                dataField: "ID_FORMULARIO",
                text: "Tipo do Formulário",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "DS_FORMULARIO",
                text: "Nome do Formulário",
                align: "center",
                headerAlign: "center",
            },
            {
                dataField: "",
                text: "Visualizar",
                align: "center",
                formatter: (_, row) => (
                    <button
                        className="btn btn-outline-primary font-weight-bold m-1"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Formulário",
                                Component: () => (
                                    <VisualizarFormulario
                                        setShow={setShow}
                                        idFormulario={row.ID_FORMULARIO}
                                        visualizandoFormRespondido={true}
                                    />
                                ),
                                size: "lg",
                            });
                        }}
                    >
                        <FontAwesomeIcon icon={faEdit} size="lg" /> Visualizar
                    </button>
                ),
                isDummyField: true,
                headerAlign: "center",
            },
        ];

        return {
            tableViewColumns,
        };
    }

    const { tableViewColumns } = useMemo(
        () => getColumns(updateList),
        [updateList]
    );

    return (
        <div className="card">
            <div className="card-body">
                <Table
                    data={listarFormulariosRespondidosPorCasoResponse ?? []}
                    loading={loading}
                    bordered={false}
                    striped={true}
                    columns={tableViewColumns}
                    keyField="ID_FORMULARIO"
                    noDataIndication={() => (
                        <div className="text-black-50 text-center">
                            Nenhuma Pesquisa de Satisfação encontrada
                        </div>
                    )}
                    center
                />
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </div>
    );
}
